 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import axios from '../../config/axios';
import axiosskillmeo from '../../config/skillmeoaxios';
import axiosmooc from '../../config/moocaxios'
const apiImportStudent = async (file) => {
    // console.log(file[0].name)
    var data = new FormData();
        data.append('excel_file', file[0],file[0].name);

    try {
        const result = await axios.post(`/v1/user/student/import_excel`, data ,{
        })
        return result
    } catch (error) {
        return _optionalChain([error, 'optionalAccess', _ => _.response, 'optionalAccess', _2 => _2.data]);
    }
}

const apiImportInstructor = async (file) => {
    var data = new FormData();
        data.append('excel_file', file[0],file[0].name);

    try {
        const result = await axios.post(`/v1/user/instructor/import_excel`, data ,{
        })
        return result
    } catch (error) {
        return _optionalChain([error, 'optionalAccess', _3 => _3.response, 'optionalAccess', _4 => _4.data]);
    }
}

const registerUser = async (payload) => {
    try {
        const result = await axios.post(`/user/register`, payload ,{ })
        return result
    } catch (error) {
        return _optionalChain([error, 'optionalAccess', _5 => _5.response]);
    }
}

const submitApplication = async (payload) => {
    try {
        const result = await axios.post(`/application`, payload ,{ })
        return result
    } catch (error) {
        return _optionalChain([error, 'optionalAccess', _6 => _6.response]);
    }
}

const validateApplication = async (payload) => {
    try {
        const result = await axios.post(`/application/verify`, payload ,{ })
        return result
    } catch (error) {
        return _optionalChain([error, 'optionalAccess', _7 => _7.response]);
    }
}

const apiImportUserUpload = async (file) => {
    var data = new FormData();
    data.append('file', file[0]);
    try {
        const result = await axios.post(`/user/import/upload`, data ,{
        })
        return result
    } catch (error) {
        return _optionalChain([error, 'optionalAccess', _8 => _8.response, 'optionalAccess', _9 => _9.data]);
    }
}

const apiImportUserConfirm = async (payload) => {
    try {
        const result = await axios.post(`/user/import/confirm`, payload ,{
        })
        return result
    } catch (error) {
        return _optionalChain([error, 'optionalAccess', _10 => _10.response, 'optionalAccess', _11 => _11.data]);
    }
}

const apiImportSkillmeoUpload = async (file) => {
    var data = new FormData();
    data.append('file', file[0]);
    try {
        const result = await axiosskillmeo.post(`/admin/user/import/upload`, data ,{
        })
        return result
    } catch (error) {
        return _optionalChain([error, 'optionalAccess', _12 => _12.response, 'optionalAccess', _13 => _13.data]);
    }
}

const apiImportSkillmeoConfirm = async (payload) => {
    try {
        const result = await axiosskillmeo.post(`/admin/user/import/confirm`, payload ,{
        })
        return result
    } catch (error) {
        return _optionalChain([error, 'optionalAccess', _14 => _14.response, 'optionalAccess', _15 => _15.data]);
    }
}

const apiImportMoocUpload = async (file) => {
    var data = new FormData();
    data.append('file', file[0]);
    try {
        const result = await axiosmooc.post(`/v1/user/import/upload`, data ,{
        })
        return result
    } catch (error) {
        return _optionalChain([error, 'optionalAccess', _16 => _16.response, 'optionalAccess', _17 => _17.data]);
    }
}

const apiImportMoocConfirm = async (payload) => {
    try {
        const result = await axiosmooc.post(`/v1/user/import/confirm`, payload ,{
        })
        return result
    } catch (error) {
        return _optionalChain([error, 'optionalAccess', _18 => _18.response, 'optionalAccess', _19 => _19.data]);
    }
}

export {
    apiImportUserUpload,
    apiImportUserConfirm,
    apiImportStudent,
    apiImportInstructor,
    apiImportSkillmeoUpload,
    apiImportSkillmeoConfirm,
    apiImportMoocUpload,
    apiImportMoocConfirm, 
    registerUser,
    submitApplication,
    validateApplication
}